module.exports = __webpack_public_path__ + "static/media/GlobalCV-Search-Clean.d5778caa.jpg";